import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Box from "../components/Box";
import PropertyLabel from "../components/PropertyLabel";
import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";
import CustomerCashList from "../components/CustomerCashList";
import CustomerPDAList from "../components/CustomerPDAList";

import { fetchCustomer, fetchCustomers } from "../actions/customers";
import { fetchSLAs } from "../actions/slas";
import AssignedZoneList from "../components/AssignedZoneList";
import AssignedComissionList from "../components/AssignedComissionList";
import AssignedItemNumber from "../components/AssignedItemNumber";
import { getLockersName } from "../utils/machines";
import "../styles/CustomerDetailsView.css";

class CustomerDetailsView extends React.Component {
  componentDidMount() {
    this.props.fetchCustomer(this.props.match.params.id);
    this.props.fetchCustomers();
    this.props.fetchSLAs();
  }

  getSAPModel(model) {
    switch (model) {
      case "VC":
        return "VENTAS CONTADO (Punto de Venta)";
      case "CV":
        return "COMISION VENTA (Solicitud Factura)";
    }
  }

  render() {
    const { role, type, customers, customer, error, loading } = this.props;

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!customer || !customers || loading) {
      return <LoadingProgress />;
    }

    return (
      <div className="customer-details-view">
        {/* Header Section */}
        <div className="cust-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-user mr-3"></i> CLIENTE {customer.Fullname}
              </h1>
            </div>

            {role === "ADMIN" && type === "MASTER" && (
              <div className="header-actions">
                <Link
                  to={`/customers/${customer._id}/edit`}
                  className="cust-admin-btn primary"
                >
                  <i className="fas fa-edit"></i>
                  <span>Editar</span>
                </Link>
                <Link
                  to={`/customerscash/${customer._id}/add`}
                  className="cust-admin-btn warning"
                >
                  <i className="fas fa-plus"></i>
                  <span>Añadir CashControl</span>
                </Link>
                <Link
                  to={`/customerspda/${customer._id}/add`}
                  className="cust-admin-btn secondary"
                >
                  <i className="fas fa-plus"></i>
                  <span>Añadir PDAControl</span>
                </Link>
              </div>
            )}
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="customer-content-grid">
          {/* Column 1 - General Info */}
          <div className="customer-column">
            {/* Customer Info Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-user mr-2"></i>
                Información del Cliente
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-user mr-2"></i>
                    Nombre completo
                  </div>
                  <div className="info-value font-weight-bold">
                    {customer.Fullname}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-id-badge mr-2"></i>
                    Tipo de licencia
                  </div>
                  <div className="info-value">
                    {customer.LicenseType === "pro" ? "Pro" : "Básica"}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-tag mr-2"></i>
                    Tipo
                  </div>
                  <div className="info-value">{customer.Type}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-layer-group mr-2"></i>
                    Categoria
                  </div>
                  <div className="info-value">{customer.Category}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-user-tie mr-2"></i>
                    Persona de contacto
                  </div>
                  <div className="info-value">{customer.Contact_person}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-envelope mr-2"></i>
                    E-Mail
                  </div>
                  <div className="info-value">{customer.Email}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-map-marker-alt mr-2"></i>
                    Dirección
                  </div>
                  <div className="info-value">{customer.Address}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-phone mr-2"></i>
                    Teléfono
                  </div>
                  <div className="info-value">{customer.Phone}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-language mr-2"></i>
                    Idioma
                  </div>
                  <div className="info-value">{customer.Language}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-mail-bulk mr-2"></i>
                    Código postal
                  </div>
                  <div className="info-value">{customer.PostalCode}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-city mr-2"></i>
                    Ciudad
                  </div>
                  <div className="info-value">{customer.City}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-map mr-2"></i>
                    Provincia
                  </div>
                  <div className="info-value">{customer.Province}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-globe mr-2"></i>
                    País
                  </div>
                  <div className="info-value">{customer.Country}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-shield-alt mr-2"></i>
                    SLA
                  </div>
                  <div className="info-value">
                    {(() => {
                      if (!customer.SLA || !this.props.slas) return "--";
                      const sla = this.props.slas.find(
                        (s) => s._id === customer.SLA,
                      );
                      if (!sla) return "--";
                      return sla.zone === "ES_PENINSULA"
                        ? "España Península"
                        : sla.zone === "ES_ISLANDS"
                          ? "España Islas"
                          : sla.zone === "EU_ZONE1"
                            ? "Europa Zona 1"
                            : sla.zone === "EU_ZONE2"
                              ? "Europa Zona 2"
                              : sla.zone;
                    })()}
                  </div>
                </div>
              </div>
            </div>

            {/* Extra Info Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-file-alt mr-2"></i>
                Información Adicional
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-users mr-2"></i>
                    Grupo al que pertenece
                  </div>
                  <div className="info-value">{customer.Group}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-external-link-alt mr-2"></i>
                    Identificador Externo
                  </div>
                  <div className="info-value">{customer.ExternalId}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-envelope-open-text mr-2"></i>
                    Email de Reportes
                  </div>
                  <div className="info-value">{customer.IncidencesEmail}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-user-edit mr-2"></i>
                    Última edición
                  </div>
                  <div className="info-value">{customer.Executor}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 2 - Business and Technical Info */}
          <div className="customer-column">
            {/* Bearer Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-key mr-2"></i>
                Bearer Token
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-key mr-2"></i>
                    Token
                  </div>
                  <div className="info-value font-weight-bold">
                    {customer._id}
                  </div>
                </div>
              </div>
            </div>

            {/* Billing Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-file-invoice-dollar mr-2"></i>
                Facturación
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-id-card mr-2"></i>
                    NIF/CIF
                  </div>
                  <div className="info-value">{customer.Invoice_taxid}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-percent mr-2"></i>
                    IVA aplicable (%)
                  </div>
                  <div className="info-value">{customer.Invoice_tax}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-building mr-2"></i>
                    Razón social
                  </div>
                  <div className="info-value">{customer.Social_name}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-map-marker-alt mr-2"></i>
                    Dirección
                  </div>
                  <div className="info-value">{customer.Invoice_address}</div>
                </div>
              </div>
            </div>

            {/* Business Model Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-briefcase mr-2"></i>
                Modelo de negocio
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-cogs mr-2"></i>
                    Modelo
                  </div>
                  <div className="info-value">{customer.BusinessModel}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-arrows-alt-v mr-2"></i>
                    Vertical
                  </div>
                  <div className="info-value">{customer.Vertical}</div>
                </div>
                {customer.SpaceRentalAlquiler && (
                  <div className="info-row">
                    <div className="info-label">
                      <i className="fas fa-euro-sign mr-2"></i>
                      Alquiler Anual
                    </div>
                    <div className="info-value">
                      {customer.SpaceRentalAlquiler} €
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Column 3 - TPV, SAP, and Assignments */}
          <div className="customer-column">
            {/* TPV Virtual Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-credit-card mr-2"></i>
                TPV Virtual
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-code mr-2"></i>
                    Código de comercio
                  </div>
                  <div className="info-value">
                    {customer.Redsys?.MERCHANTCODE}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-lock mr-2"></i>
                    Clave de cifrado
                  </div>
                  <div className="info-value">{customer.Redsys?.SECRETKEY}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-coins mr-2"></i>
                    Moneda
                  </div>
                  <div className="info-value">{customer.Redsys?.CURRENCY}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-desktop mr-2"></i>
                    Terminal
                  </div>
                  <div className="info-value">{customer.Redsys?.TERMINAL}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-link mr-2"></i>
                    URL Tienda
                  </div>
                  <div className="info-value">
                    {customer.Redsys?.MERCHANTURL}
                  </div>
                </div>
              </div>
            </div>

            {/* SAP Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-industry mr-2"></i>
                SAP
              </div>
              <div className="card-body-custom">
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-cogs mr-2"></i>
                    Model
                  </div>
                  <div className="info-value">
                    {this.getSAPModel(customer.SAP?.Model)}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-building mr-2"></i>
                    CompanyID
                  </div>
                  <div className="info-value">{customer.SAP?.CompanyID}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-globe mr-2"></i>
                    CountryCode
                  </div>
                  <div className="info-value">{customer.SAP?.CountryCode}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-user mr-2"></i>
                    ClientID
                  </div>
                  <div className="info-value">{customer.SAP?.ClientID}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-map-marker-alt mr-2"></i>
                    SiteID
                  </div>
                  <div className="info-value">{customer.SAP?.SiteID}</div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-flag mr-2"></i>
                    TaxCountryCode
                  </div>
                  <div className="info-value">
                    {customer.SAP?.TaxCountryCode}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-calculator mr-2"></i>
                    TaxationCharacteristicsCode
                  </div>
                  <div className="info-value">
                    {customer.SAP?.TaxationCharacteristicsCode}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-warehouse mr-2"></i>
                    InventoryManagedLocationID
                  </div>
                  <div className="info-value">
                    {customer.SAP?.InventoryManagedLocationID}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-truck mr-2"></i>
                    LogisticsAreaID
                  </div>
                  <div className="info-value">
                    {customer.SAP?.LogisticsAreaID}
                  </div>
                </div>
                <div className="info-row">
                  <div className="info-label">
                    <i className="fas fa-map mr-2"></i>
                    TaxRegionCode
                  </div>
                  <div className="info-value">
                    {customer.SAP?.TaxRegionCode}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Column 4 - Assignments */}
          <div className="customer-column">
            {/* Articles Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-shopping-cart mr-2"></i>
                Artículos
              </div>
              <div className="card-body-custom">
                <AssignedComissionList items={customer.Items} />
              </div>
            </div>

            {/* Zones Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-door-closed mr-2"></i>
                Zonas
              </div>
              <div className="card-body-custom">
                <AssignedZoneList Zones={customer.Zones} />
              </div>
            </div>

            {/* Cash Control Users Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-dark">
                <i className="fas fa-user mr-2"></i>
                Usuarios Cash Control
              </div>
              <div className="card-body-custom">
                <CustomerCashList customers={customers} customer={customer} />
              </div>
            </div>

            {/* PDA Control Users Card */}
            <div className="customer-card">
              <div className="card-header-custom bg-vw-light">
                <i className="fas fa-user mr-2"></i>
                Usuarios PDA Control
              </div>
              <div className="card-body-custom">
                <CustomerPDAList customers={customers} customer={customer} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customers: state.customers.customers,
  customer: state.customers.customer,
  loading: state.customers.loading,
  error: state.customers.error,
  role: state.auth.role,
  type: state.auth.type,
  slas: state.slas.slas,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  fetchSLAs: bindActionCreators(fetchSLAs, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomerDetailsView);
